<app-loading *ngIf="!contentReady"></app-loading>

<div class="job-list-page container-fluid" dir="rtl" *ngIf="contentReady">
  <div class="page-card">

    <!-- Header -->
    <div class="job-header">
      <div>
        <h2>قائمة الوظائف</h2>
        <p>إدارة الوظائف المنشورة والمسودات والوظائف المغلقة</p>
      </div>

      <div class="header-actions">
        <button class="main-btn" routerLink="/create-job">
          + إضافة وظيفة
        </button>

        <button class="secondary-btn" (click)="refresh()">
          تحديث
        </button>
      </div>
    </div>

    <!-- Search -->
    <div class="search-box">
      <input
        type="text"
        [(ngModel)]="filters.search"
        (keyup.enter)="applyFilters()"
        placeholder="ابحث باسم الوظيفة أو الوصف أو المسؤوليات"
      />

      <button (click)="applyFilters()">بحث</button>
    </div>

    <!-- Filters -->
    <div class="filters-box">

      <div class="filter-item">
        <label>حالة الوظيفة</label>
        <select [(ngModel)]="filters.status" (change)="applyFilters()">
          <option value="">كل الحالات</option>
          <option value="draft">مسودة</option>
          <option value="published">منشورة</option>
          <option value="closed">مغلقة</option>
        </select>
      </div>

      <div class="filter-item">
        <label>نظام العمل</label>
        <select [(ngModel)]="filters.work_model" (change)="applyFilters()">
          <option value="">كل الأنظمة</option>
          <option value="on_site">من مقر العمل</option>
          <option value="remote">عن بُعد</option>
          <option value="hybrid">هايبرد</option>
        </select>
      </div>

<div class="filter-item">
  <label>الدولة</label>
  <select
    [(ngModel)]="filters.country_id"
    (change)="onCountryChange()"
  >
    <option value="">كل الدول</option>

    <option *ngFor="let country of countries" [value]="country.id">
      {{ country.country_name_ar || country.country_name_en }}
    </option>
  </select>
</div>

<div class="filter-item">
  <label>المدينة</label>
  <select
    [(ngModel)]="filters.city_id"
    (change)="applyFilters()"
    [disabled]="!filters.country_id"
  >
    <option value="">كل المدن</option>

    <option *ngFor="let city of filteredCities" [value]="city.id">
      {{ city.city_name_ar || city.city_name_en }}
    </option>
  </select>
</div>

<div class="filter-item">
  <label>المدينة</label>
  <input
    type="text"
    [(ngModel)]="filters.city"
    (keyup.enter)="applyFilters()"
    placeholder="مثال: الرياض"
  />
</div>
      <div class="filter-actions">
        <button class="main-btn" (click)="applyFilters()">تطبيق الفلاتر</button>
        <button class="clear-btn" (click)="resetFilters()">مسح الفلاتر</button>
      </div>

    </div>

    <!-- Table -->
    <div class="table-wrapper" *ngIf="!noData">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 jobs-table">

        <!-- Job Title -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>الوظيفة</th>
          <td mat-cell *matCellDef="let el">
            <div class="job-title">
              <strong>{{ el.title_ar || el.title_en || 'بدون عنوان' }}</strong>
              <small *ngIf="el.title_en">{{ el.title_en }}</small>
            </div>
          </td>
        </ng-container>

        <!-- Location -->
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>المكان</th>
          <td mat-cell *matCellDef="let el">
<span>{{ getJobCountryName(el) }}</span>
<br />
<small>{{ getJobCityName(el) }}</small>
          </td>
        </ng-container>

        <!-- Job Type -->
        <ng-container matColumnDef="job_type">
          <th mat-header-cell *matHeaderCellDef>نوع العمل</th>
          <td mat-cell *matCellDef="let el">
            <span class="mini-badge blue">
              {{ getWorkModelLabel(el.work_model) }}
            </span>
            <br />
            <span class="mini-badge gray">
              {{ getEmploymentTypeLabel(el.employment_type) }}
            </span>
          </td>
        </ng-container>

        <!-- Salary -->
        <ng-container matColumnDef="salary">
          <th mat-header-cell *matHeaderCellDef>الراتب</th>
          <td mat-cell *matCellDef="let el">
            {{ formatSalary(el) }}
          </td>
        </ng-container>

        <!-- Requirements -->
        <ng-container matColumnDef="requirements">
          <th mat-header-cell *matHeaderCellDef>المتطلابات </th>
          <td mat-cell *matCellDef="let el">
            <div class="chips">
              <span
                class="chip"
                *ngFor="let req of (el.requirements || []).slice(0, 3)"
              >
                {{ req.requirement_text }}
              </span>

              <span class="more-chip" *ngIf="(el.requirements || []).length > 3">
                +{{ toArabicNumber((el.requirements || []).length - 3) }}
              </span>

              <span class="empty-text" *ngIf="!(el.requirements || []).length">
                لا يوجد
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Skills -->
        <ng-container matColumnDef="skills">
          <th mat-header-cell *matHeaderCellDef>المهارات</th>
          <td mat-cell *matCellDef="let el">
            <div class="chips">
              <span
                class="skill-chip"
                *ngFor="let skill of (el.skills || []).slice(0, 3)"
              >
                {{ skill.name_ar || skill.name_en || skill.name || 'مهارة' }}
              </span>

              <span class="more-chip" *ngIf="(el.skills || []).length > 3">
                +{{ toArabicNumber((el.skills || []).length - 3) }}
              </span>

              <span class="empty-text" *ngIf="!(el.skills || []).length">
                لا يوجد
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Exam -->
        <ng-container matColumnDef="exam">
          <th mat-header-cell *matHeaderCellDef>الاختبارات</th>
          <td mat-cell *matCellDef="let el">
            <span class="yes" *ngIf="el.exam_required">اختبار مطلوب</span>
            <span class="no" *ngIf="!el.exam_required">بدون اختبار</span>

            <br />

            <span class="yes" *ngIf="el.personality_assessment_required">
              تقييم شخصية
            </span>
            <span class="no" *ngIf="!el.personality_assessment_required">
              بدون تقييم
            </span>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>الحالة</th>
          <td mat-cell *matCellDef="let el">
            <span class="status-badge" [ngClass]="el.status">
              {{ getStatusLabel(el.status) }}
            </span>
          </td>
        </ng-container>

        <!-- Date -->
        <ng-container matColumnDef="posted_at">
          <th mat-header-cell *matHeaderCellDef>تاريخ النشر</th>
          <td mat-cell *matCellDef="let el">
            {{ formatDate(el.posted_at || el.created_at) }}
            <br />
            <small>مشاهدات: {{ toArabicNumber(el.views_count || 0) }}</small>
          </td>
        </ng-container>

        <!-- Options -->
        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="dropdown">
              <button
                class="options-btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                ⋮
              </button>

              <ul class="dropdown-menu">
                <li *ngIf="element.status !== 'published'">
                  <a class="dropdown-item" (click)="changeStatus(element, 'published')">
                    نشر الوظيفة
                  </a>
                </li>

                <li *ngIf="element.status !== 'draft'">
                  <a class="dropdown-item" (click)="changeStatus(element, 'draft')">
                    تحويل لمسودة
                  </a>
                </li>

                <li *ngIf="element.status !== 'closed'">
                  <a class="dropdown-item" (click)="changeStatus(element, 'closed')">
                    إغلاق الوظيفة
                  </a>
                </li>

                <li>
                  <a class="dropdown-item" (click)="editJob(element)">
                    تعديل
                  </a>
                </li>

                <li>
                  <a class="dropdown-item text-danger" (click)="deleteJob(element)">
                    حذف
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      </table>

<mat-paginator
  class="aes-paginator"
  [length]="totalItems"
  [pageSize]="perPage"
  [pageIndex]="currentPage - 1"
  [pageSizeOptions]="[10, 15, 25, 50]"
  [showFirstLastButtons]="true"
  (page)="onPaginateChange($event)">
</mat-paginator>
    </div>

    <!-- No Data -->
    <div class="no-data-box" *ngIf="noData">
      <app-nodata></app-nodata>
    </div>

  </div>
</div>